import GridGallery from './grid_gallery';

export default GridGallery;
